module.exports = __webpack_public_path__ + "files/80be1a0a295ee327a916c45995a7aae3.png";